export default "__VITE_ASSET__Cd9uCphc__"